import React from 'react';
import './ApprovalTimeline.css';

function ApprovalTimeline({ flow = [], ticketStatus }) {
  if (!flow.length) {
    return null;
  }

  const formatDate = (date) => {
    if (!date) return '';
    return new Date(date).toLocaleString();
  };

  const nodes = [
    {
      key: 'new',
      label: 'New',
      state: 'complete',
      description: 'Ticket submitted',
    },
  ];

  flow.forEach((step) => {
    let label = `${step.role}`;
    let description = '';
    let state = 'pending';
    let tooltipContent = '';

    // Build comprehensive tooltip content
    const tooltipParts = [];

    if (step.approver_name) {
      tooltipParts.push(`Approver: ${step.approver_name}`);
    }
    if (step.approver_email) {
      tooltipParts.push(`Email: ${step.approver_email}`);
    }
    if (step.acted_by_name) {
      tooltipParts.push(`Acted By: ${step.acted_by_name}`);
    }
    if (step.acted_by_email && step.acted_by_email !== step.acted_by_name) {
      tooltipParts.push(`Acted By Email: ${step.acted_by_email}`);
    }
    if (step.acted_at) {
      tooltipParts.push(`Date: ${formatDate(step.acted_at)}`);
    }
    if (step.justification) {
      tooltipParts.push(`Justification: ${step.justification}`);
    }
    if (step.order) {
      tooltipParts.push(`Step Order: ${step.order}`);
    }

    tooltipContent = tooltipParts.join('\n');

    if (step.status === 'Pending') {
      label = `Waiting for ${step.role} (${step.approver_name || 'TBD'})`;
      description = 'Awaiting decision';
      state = 'pending';
    } else if (step.status === 'Approved') {
      label = `${step.role} Approved`;
      description = `${step.approver_name || step.role} • ${formatDate(
        step.acted_at
      )}`;
      if (step.justification) {
        description += ` • "${step.justification}"`;
      }
      state = 'complete';
    } else if (step.status === 'Rejected') {
      label = `${step.role} Rejected`;
      description = `${step.approver_name || step.role} • ${formatDate(
        step.acted_at
      )}`;
      if (step.justification) {
        description += ` • "${step.justification}"`;
      }
      state = 'rejected';
    } else if (step.status === 'Skipped') {
      label = `${step.role} Skipped`;
      state = 'skipped';
    }

    nodes.push({
      key: `step-${step.id}`,
      label,
      description,
      state,
      tooltip: tooltipContent,
    });
  });

  const finalState =
    ticketStatus === 'Approved'
      ? 'approved'
      : ticketStatus === 'Rejected'
        ? 'rejected'
        : 'pending';

  nodes.push({
    key: 'final',
    label:
      finalState === 'approved'
        ? 'Approved'
        : finalState === 'rejected'
          ? 'Rejected'
          : 'Awaiting Final Decision',
    state: finalState === 'pending' ? 'pending' : 'complete',
  });

  return (
    <div className="approval-timeline">
      {nodes.map((node, idx) => (
        <div
          className="approval-timeline-step"
          key={node.key}
          title={node?.tooltip?.toLocaleString() || ''}
        >
          <div className="approval-timeline-marker-wrapper">
            <div className={`approval-marker ${node.state}`}>
              <span className="marker-dot" />
            </div>
            {idx !== nodes.length - 1 && (
              <div className={`approval-connector ${node.state}`} />
            )}
          </div>
          <div className="approval-timeline-content">
            <div className="approval-label">{node.label}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ApprovalTimeline;

